import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AdminPageLayout from '../../layout/AdminPageLayout';
import { useAppDispatch } from '../../store';
import Headline from '../../ui/Headline';
import { setIsModalOpen, setModalContent } from '../../store/slices/global';
import { MODAL_CONTENT } from '../../app.config.vars/modalContent';
import { getRalliesTargetGroups, getRalliesThemes, } from '../../api/game-mode/rallies-filter-options';
import Loader from '../../ui/Loader';
import AdminRallyForm from '../../forms/AdminContentForms/adminRally';
import ShareQR from '../../components/ShareQR';
import AsideContentLayout from '../AsideContentLayout';
import { useSelector } from 'react-redux';
import { selectAdminRally } from '../../store/adminSlices/rallies';
const AdminRallyPageLayout = ({ title, formType, rallyId }) => {
    const { i18n } = useTranslation();
    const dispatch = useAppDispatch();
    const [themes, setThemes] = useState(null);
    const [targetGroups, setTargetGroups] = useState(null);
    const rally = useSelector(selectAdminRally);
    useEffect(() => {
        const fetchRallyData = async () => {
            try {
                const themes = await getRalliesThemes();
                const targetGroups = await getRalliesTargetGroups();
                setThemes(themes);
                setTargetGroups(targetGroups);
            }
            catch (err) {
                dispatch(setIsModalOpen(true));
                dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
            }
        };
        fetchRallyData();
    }, [i18n.language]);
    const mainContent = (_jsxs(_Fragment, { children: [_jsx("div", { className: "page-header-top", children: _jsx(Headline, { title: title, type: 'h1' }) }), themes && targetGroups ? (_jsx(AdminRallyForm, { formType: formType, rallyId: rallyId, themes: themes, targetGroups: targetGroups })) : (_jsx(Loader, {}))] }));
    return (_jsx(AdminPageLayout, { logoutButton: true, children: _jsx("div", { className: 'page-content-wrapper admin-rally-page', children: formType === 'edit' && rally?.status === 1 ? (_jsx(AsideContentLayout, { mainContent: mainContent, asideContent: _jsx(ShareQR, { url: `${location.origin}/rallies/${rally.uuid}`, description: "admin.qr_code_for_rally", title: "admin.qr_code_public_rally_link" }) })) : (mainContent) }) }));
};
export default AdminRallyPageLayout;
